export default __webpack_public_path__ + "static/media/gamers_outlet.d24a1a3a.png";